<template>
    <div class="checkbox-wrapper">
        <input
                ref="checkbox"

                class="k-checkbox custom-kendo-checkbox-for"
                type="checkbox"
                v-bind:checked="checked"
        />

        <label
                class="k-checkbox-label"
                @click.self.prevent="clicked"
        >
            {{label}}
        </label>
    </div>
</template>

<script>
    import {guid} from "../../../../Util/guid";

    //IE is trash, thus we need to explicitly listen to our label for click events
    //instead of just input on our checkbox
    
    export default {
        name: "scenario-list-item-checkbox",
        created(){
            const vm = this;
            vm.controlId = `CHK_${guid()}`;

            //Pre-checked = active = readonly
            vm.checked = vm.value;
            vm.readonly = vm.value;
        },
        methods: {
            clicked(){
                const vm = this;
                const el = vm.$refs.checkbox;
                
                //Force re-check
                if(vm.readonly){
                    el.checked = true;
                    return;
                }
                
                //Toggle checked
                vm.checked = !vm.checked;
                el.checked = vm.checked;
                
                vm.$emit('input', vm.checked);
            }
        },
        data: () => ({
            controlId: '',
            checked: false,
            readonly: false
        }),
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: Boolean,
                required: true
            }
        }
    }
</script>

<style scoped src="../../Style/scenario-list-item-checkbox.scss" lang="scss">
</style>
